import { render, staticRenderFns } from "./credito.vue?vue&type=template&id=2f0ff5ca&scoped=true"
import script from "./credito.vue?vue&type=script&lang=js"
export * from "./credito.vue?vue&type=script&lang=js"
import style0 from "./credito.vue?vue&type=style&index=0&id=2f0ff5ca&prod&lang=css"
import style1 from "./credito.vue?vue&type=style&index=1&id=2f0ff5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0ff5ca",
  null
  
)

export default component.exports